import React, { Component } from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CertLegalFormModel from "../../models/certlegalform";
import { userService } from "../../services";
import {enumReferTypes, enumDeathLocation,enumWomanPrognancyStatus, identityCodeStatus,enumResidenceStatus,enumEducationStatus} from "../../constants/enum.constants";
import EnumRadioInput from "../../helpers/enumRadioInput";

class CertReqLegalFormPartial extends Component {
    constructor(props) {
        super(props);
        this.refreshText = this.refreshText.bind(this)
        this.state = {
           model:new CertLegalFormModel(this.refs)
          }

        this.submit=this.submit.bind(this);  
     
    }

    modules = {
        toolbar: [
       
          ['bold', 'italic', 'underline','strike'],
          [{ 'direction': 'rtl' }], 
          
          [{ 'align': [] }],
         
        ],
        history: {
            delay: 2000,
            maxStack: 500,
            userOnly: true
        }
      };
    
      formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent','direction','align'
        
      ];

    componentDidMount()
    {
        let model=new CertLegalFormModel(this.refs);
        this.setState({
            model:model
        })
        if(this.props.form!=null)
        {
            model=this.props.form;
            this.setState({
                model:model
            })
        }
    }
    refreshText(value) {
        const {model}= this.state;
        var name="LegalText";
        var value=value;
        model[name]=value;

        this.setState({

            model:model

        });

        
    }

    submit(){
        const {model}= this.state;

        let viewmodel= {
            Id:model.Id,
            FormType:0, // legal formtype,
            LegalForm: model,
            MoralForm:null
        }

        this.props.submitCertFormHandler(viewmodel);
      
      }

   
    render() { 


        const {form} = this.props;
        const {model}= this.state;

        console.log('_MODEL',form) 
        return (  

            <div>
                                   
                <div className="row">
                   
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                
                                    <div className="toolbox">

                                        <button type="button"  className="btn btn-default btn-sm"  onClick={this.submit}><i className="fa fa-save"></i>   ثبت اطلاعات
                                        
                                        </button>
                                    
                                    </div>
                                </div>
                        </div>
                    
                    <div className="col-md-12">
                        <input type="hidden" value={form && form.Id} name="Id" ref="Id"></input>
                        <input type="hidden"  value={form && form.CertificationRequestId} name="CertificationRequestId" ref="CertificationRequestId"></input>
                        <ReactQuill
                            value={model.LegalText}
                             modules={this.modules}
                             name="LegalText"
                             ref="LegalText"
                             formats={this.formats}
                             style={{minHeight:250}}
                             onChange={this.refreshText} />
                       
               
                   
                    </div> 
                    <div className="col-md-12">
                        <fieldset><legend>علت مراجعه</legend>
                            <EnumRadioInput enumObj={enumReferTypes}  name="enumReferType" ref="enumReferTypes" ></EnumRadioInput>
                        </fieldset>
                        </div>          
                </div>

            </div>
  
        );
    }
}
 
export default CertReqLegalFormPartial;